export function createAutoLoopPlugin() {
  return (slider) => {
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
      clearTimeout(timeout)
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next()
      }, 4000)
    }

    slider.on("created", () => {
      /*
      slider.container.parentNode.addEventListener("mouseenter", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.parentNode.addEventListener("mouseleave", () => {
        mouseOver = false
        nextTimeout()
      })
      */
      /*const arrows = slider.container.parentNode.querySelectorAll('.arrow');

      arrows.forEach((arrow) => {
        arrow.addEventListener("mouseover", () => {
          console.log('arrow mouseover')
          mouseOver = true
          clearNextTimeout()
        })
      })*/
      nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  }
}
